export default {
  supplierManagement: {
    // 页面标题
    pageTitle: '供应商管理',
    detailPageTitle: '供应商打分详情',

    // 分类卡片
    classification: {
      title: '供应商分类',
      all: '全部供应商'
    },

    // 搜索筛选
    search: {
      placeholder: '搜索供应商名称、联系人或手机号',
      location: '所在地区',
      button: '搜索'
    },

    // 列表卡片
    list: {
      title: '供应商列表',
      defaultSort: '默认排序',
      sortOptions: {
        scoreDesc: '总分降序',
        scoreAsc: '总分升序'
      },
      columns: {
        name: '供应商名称',
        score: '地区综合评分',
        category: '分类',
        status: '合作状态',
        operation: '操作'
      },
      pagination: '显示 {pageSize} 条/页, 共 {total} 条记录'
    },

    // 详情页操作
    actions: {
      editScore: '编辑评分',
      saveScore: '保存评分',
      cancel: '取消'
    },

    // 详情页基本信息
    baseInfo: {
      title: '公司信息',
      contact: '负责人：',
      phone: '电话：',
      email: '邮箱：',
      location: '所在地区：',
      totalScore: '总分：'
    },

    // 评分卡片
    scoring: {
      title: '评分详情',
      tabs: {
        introduce: '引进评价',
        usage: '使用评级'
      },
      columns: {
        index: '序号',
        scope: '评估范围',
        maxScore: '分值',
        item: '评估项目',
        description: '描述',
        path: '查询路径',
        remarks: '备注',
        score: '得分',
        totalScore: '总分：'
      },
      veto: {
        placeholder: '请输入备注'
      },
      displayRules: {
        perEvent: '/次',
        cap: '，上限{cap}'
      },
      rules: {
        introduce: '引进评价规则：\n1、引进：总分在80分（含）以上\n2、储备：总分在60（含）-79分\n3、不引进：总分在59分以下',
        usage: '使用评级规则：\n1、优秀：总分在85分（含）以上\n2、良好：总分在70分（含）以上\n3、合作：总分在60分（含）以上\n4、限时整改：总分在59分以下'
      }
    },

    // 状态枚举
    enums: {
      introduce: {
        introduced: '引进',
        reserved: '储备',
        rejected: '不引进'
      },
      usage: {
        excellent: '优秀',
        good: '良好',
        cooperating: '合作',
        rectifying: '限时整改'
      },
      cooperation: {
        cooperating: '合作中',
        pending: '待合作',
        evaluating: '评估中',
        terminated: '已淘汰'
      }
    },

    // 审核结果
    audit: {
      approve: '通过',
      reject: '拒绝'
    },

    // 角色翻译
    roles: {
      ROLE_SHIPPER: '发货人',
      ROLE_CONSIGNEE: '收货人',
      ROLE_NOTIFY: '通知人',
      ROLE_CARRIER: '船公司',
      ROLE_AIRLINE: '航空公司',
      ROLE_TRUCK: '卡车公司',
      ROLE_WAREHOUSE: '仓库',
      ROLE_CUSTOMS: '报关行',
      ROLE_FORWARDER: '货代',
      ROLE_AGENT: '代理',
      ROLE_SUPPLIER: '供应商',
      ROLE_FACTORY: '工厂/生产商',
      ROLE_TRADER: '贸易商'
    },
    evaluationItems: {
      spaceGuarantee: '仓位保障',
      priceCompetition: '价格竞争',
      serviceEfficiency: '服务效率',
      digitalCapability: '数字化能力',
      comprehensive: '综合评价'
    },

    // 消息提示
    messages: {
      loadRolesFailed: '加载供应商角色列表失败',
      loadDataFailed: '加载数据失败',
      saveSuccess: '保存成功',
      saveFailed: '保存评分失败',
      noChanges: '没有分值变动，无需保存',
      enterpriseIdRequired: '企业ID不能为空',
      scoreRangeError: '分值超出允许范围',
      loadDetailFailed: '加载评价详情失败',
      getEnterpriseIdFailed: '无法获取企业ID'
    }
  }
}
